module.exports = __webpack_public_path__ + "img/logo.ae3fb9f9.png";